export const FreePayment = () => {
  return <div className='text-content-title py-4 text-sm'>Produto gratuíto, sem custo para o cliente.</div>;
};
